module.exports = __webpack_public_path__ + "img/ico_lock-accent.c4521f8e.svg";